import { CartLinesUpdateEvent } from '@shopify/events';

export function initRecommendationQuickAdd() {
  document.querySelectorAll('[data-ptbr-quick]').forEach(button => {
    if (button.dataset.bound) return;
    button.dataset.bound = '1';
    const card = button.closest('.ptbr__card');
    if (!card) return;
    const status = document.createElement('p');
    status.className = 'ptbr__status';
    status.setAttribute('role', 'status');
    card.append(status);
    button.addEventListener('click', async event => {
      event.preventDefault();
      event.stopPropagation();
      if (button.disabled) return;
      if (button.dataset.checkCart === 'true') {
        window.location.href = button.dataset.cartUrl || '/cart';
        return;
      }
      const id = button.dataset.ptbrQuick;
      if (!/^\d+$/.test(id || '')) {
        status.textContent = 'Please open the product to select an available size.';
        return;
      }
      const label = button.textContent;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'ADDING…';
      status.textContent = '';
      const cartUrl = button.dataset.cartUrl || '/cart';
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      let added = false;
      try {
        const response = await fetch(button.dataset.cartAdd || '/cart/add.js', {
          method: 'POST', credentials: 'same-origin', signal: controller.signal,
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: 1 }] })
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          status.textContent = typeof result.description === 'string' ? result.description : 'This item could not be added. Open the product to check its available sizes.';
          button.textContent = 'TRY AGAIN';
          return;
        }
        added = true;
        button.textContent = 'ADDED ✓';
        status.textContent = (button.dataset.productTitle || 'Product') + ' added to your cart.';
        const cartResponse = await fetch(cartUrl + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: controller.signal });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          button.dispatchEvent(new CartLinesUpdateEvent({
            action: 'add', context: 'product', lines: [{ merchandiseId: id, quantity: 1 }],
            promise: Promise.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { source: 'protier-recommendations', itemCount: 1 } })
          }));
        }
      } catch {
        if (added) {
          status.textContent = 'Added to your cart. Open Cart to review your items.';
          button.textContent = 'ADDED ✓';
        } else {
          status.textContent = 'We could not confirm the add. Check your cart before trying again.';
          button.textContent = 'CHECK CART';
          button.dataset.checkCart = 'true';
        }
      } finally {
        clearTimeout(timeout);
        button.removeAttribute('aria-busy');
        button.disabled = false;
        if (!button.textContent) button.textContent = label;
      }
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initRecommendationQuickAdd);
else initRecommendationQuickAdd();
document.addEventListener('shopify:section:load', initRecommendationQuickAdd);
